import axios from "axios";
import {isDebug, isDesktop, isIe11, isImageDebug, isTablet, isTabletDevice, isTestServer} from "./globalVars";
import SectionTitle from "./section-title";
import {CustomEventHandler} from "../utils/CustomEventHandler";
import ScrollToggle from "../lib/scroll/scroll-toggle";
import Address from "./address";
import barba from "@barba/core";
import {HtmlUtil} from "../utils/HtmlUtil";
import Header from "./header";
import {isHtmlTest} from "../../../setting/site-data";
import siteData from "/setting/site-data";

export default class Page {
    constructor(
        namespace = '',
        dataURL = '/static/json/data_guide.json'
    ) {
        this.namespace = namespace;
        this.dataURL = dataURL;
        this.isLoaded = false;
        this.mcustNo = undefined;
        this.data = {};
    }

    init() {
        if (isDebug) console.log('- 1 > init');
    }

    load() {
        if (isDebug) console.log('- 2 > load');
        console.log(this.dataURL);

        return new Promise(resolve=>{
            gfnSsoReqHttp(resolve);
            if (isDebug) console.log('- 2.1 > login-load');
        }).then((response) =>{
            if (isDebug) console.log('- 2.2 > login-loaded');
            if (isDebug) console.log(response);
            if (isDebug) console.log('- 2.3 > data-load')

            if(response.mcustNo) {
                this.mcustNo = response.mcustNo;
            }

            // "mcustNo" : "13e12312",
            //     "rtnMsg" : "토큰발급 성공",
            //     "succYn" : "Y"
            // console.log(document.querySelector('#mcustNo'));

            // 주석
            let postData = 'mcustNo=' + response.mcustNo;

            // magazine, news  에서  page , idx 처리
            let urlParam = HtmlUtil.getUrlParams();
            if (urlParam.idx) {
                postData += '&idx=' + urlParam.idx;
            }
            if (urlParam.page) {
                postData += '&page=' + urlParam.page;
            }

            let postType;
            if (siteData.url_data === '/static/json_static/') {
                postType = 'get';
            } else {
                postType = 'post';
            }


            return new Promise((resolve, reject)=> {
                $.ajax({
                    url: this.dataURL,
                    data: postData,
                    type: postType,
                    dataType: 'json',
                    success: (result)=> {
                        console.log('ajax load --> ' + this.dataURL);
                        let response = {};
                        response.data = result;
                        this.setDataLoaded(response);
                        resolve();
                    },
                    error: function(XMLHttpRequest, textStatus, errorThrown) {
                        console.log(textStatus);
                        // window.location = '/mypage/login/';
                    }
                })
            });
        })
    }

    setDataLoaded(response) {
        if (isDebug) console.log('- 3 > data load complete');
        if (isDebug) console.log(response.data);

        this.isLoaded = true;
        this.data = response.data;

        // Reward 체크
        if(this.namespace === 'mypage-reward'){
            if(this.data.page.data.member.rwrd_sh == "false"){
                HtmlUtil.goLink('/');
            }
        }

        this.checkLogin();
    }

    setEl(el) {
        if (isDebug) console.log('- 4 > setEl');
        console.log(this.namespace);

        if (!el) el = document;
        this.el = el;

        this.setPage();
        this.mount();
    }

    checkLogin() {
        let header = new Header();
        // 오에라 회원이 로그인 한 경우
        console.log('--------->' + this.data.page.data.member.id);
        if (this.data.page.data.member.id) {
            // 로그인 된 상태에서 login 페이지를 열면 membership page 로 이동
            if ( this.namespace === 'mypage-login') {
                HtmlUtil.goLink('/mypage/membership/');
            }
            header.setLogin();
            return;
        }

        header.setLogout();
        // 로그인이 안되어 있는 상황에서  mypage 쪽으로 올 경우 login 페이지 로 이동
        if ( this.namespace === 'mypage-membership' || this.namespace === 'mypage-point' ||  this.namespace === 'mypage-modify' || this.namespace === 'mypage-reward') {
            HtmlUtil.goLink('/mypage/login/');
        }

        // 오에라 회원이 아니나 통합 멤버쉽 회원 인 경우
        if (this.mcustNo) {
            fnCuChangeJoin();
        }
    }

    setPage() {

    };

    mount() {
        this.sectionTitle = new SectionTitle(this.el);

        let imgEls = this.el.querySelectorAll('img');
        this.imgTotal = imgEls.length;
        this.imgLoaded = 0;

        imgEls.forEach((imgEl)=> {
            let img = new Image();
            if (isImageDebug) console.log(imgEl);
            CustomEventHandler.addHandler(img,'load', ()=>{
                this.onImgLoadHandler();});
            img.src= imgEl.src;
        })

        if (this.imgTotal === 0) {
            this.setShow();
        }
    }

    onImgLoadHandler() {
        this.imgLoaded ++;

        if (this.imgLoaded === this.imgTotal) {
            if (isDebug) console.log('- imageloaded ' + this.imgLoaded + '  / ' +this.imgTotal);
            this.setShow();
        }
    }

    setShow() {
        if (isDebug) console.log('- 5 > show');
        window.dispatchEvent(CustomEventHandler.polyfillEvent('resize'));

        this.sectionTitle.setShow();
        this.setVideoPlay(true);

        let address = new Address();
        address.setScroll(this.el);
        address.setHideLoading();
        this.scrollToggle = new ScrollToggle(this.el);
    }

    setVideoPlay(isPlay) {
        let videoEls = this.el.querySelectorAll('video');
        if (videoEls.length === 0) return;

        videoEls.forEach((el)=> {
            if (el.poster) {
                let srcURL = String(el.poster).split('.png')[0] + '.mp4';
                el.querySelector('source').setAttribute('src', srcURL);
                el.load();
            }
        })

        if (isPlay) {
            videoEls.forEach((el)=>{
                if (el.autoplay === true) {
                    el.play();
                }});
        } else {
            videoEls.forEach((el)=>{el.pause()});
        }
    }

    setMemberData() {
        const memberData = this.data.page.data.member;
        document.querySelector('.section-title .data-id').innerHTML = memberData.id;
        document.querySelector('.section-title .data-grade').innerHTML = memberData.grade;
        document.querySelector('.section-title .data-point').innerHTML = memberData.point + ' point';
    }

    setPaging(currentPage, totalPage, el) {
        console.log('totalPage - ' + totalPage);
        if (totalPage === 1) {
            el.style.display = 'none';
            return;
        }

        const unit = 5;

        let i;
        let startPage = currentPage-2;
        if (startPage < 1) {
            startPage = 1;
        }
        let endPage = startPage + unit - 1;
        if (endPage > totalPage) {
            endPage = totalPage;
        }
        let pagingElStr = '';
        let activeClassStr = 'class="active"';

        let listPage;
        if (this.namespace === 'news-list') {
            listPage = '/highlights/news/';
        } else {
            listPage = '/highlights/magazine/';
        }

        for (i=startPage; i<=endPage;i++) {
            if (i===currentPage) {
                pagingElStr += `<a href="${listPage}?page=${i}" ${activeClassStr}>${i}</a>`;
            } else {
                pagingElStr += `<a href="${listPage}?page=${i}">${i}</a>`;
            }
        }

        el.innerHTML = pagingElStr;
    }

    setDestroy() {
        if (isDebug) console.log('- 6 > destroy');

        this.sectionTitle.setDestroy();
        this.scrollToggle.setDestroy();

        this.scrollToggle = undefined;
        this.sectionTitle = undefined;
        this.removeEvent();
        this.setVideoPlay(false);
    }

    addEvent() {

    }

    removeEvent() {
        CustomEventHandler.removeAllHandler();
    }
}
